// src/components/common/LoadingState.tsx
import React from 'react';

interface LoadingStateProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
}

const LoadingState: React.FC<LoadingStateProps> = ({ 
  message = 'Loading...', 
  size = 'medium' 
}) => {
  const spinnerSizes = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12',
    large: 'h-16 w-16'
  };

  return (
    <div className="flex flex-col justify-center items-center p-8">
      <div className={`animate-spin rounded-full ${spinnerSizes[size]} border-t-2 border-b-2 border-destiny-gold mb-3`}></div>
      {message && <p className="text-gray-300">{message}</p>}
    </div>
  );
};

export default LoadingState;